import React from "react";
import { ADMIN_IMAGES_URL } from "@appsinti/common-utils/constants/urls";
import { CardContentContainer, TitleContainer, ImageLarge } from "../../cardStyles";
import IGroup from "@appsinti/common-utils/interfaces/IGroup";
import { WidthRestriction } from "../../../interfaces/Restrictions";
import ChevronRight from "../CevronRight";

const EmptyCard: React.FC<{
  groups: { [key: number]: IGroup };
  groupId: number;
  widthRestriction: WidthRestriction;
  bigger?: boolean;
}> = ({ groups, groupId, widthRestriction }) => {
  return (
    <>
      <TitleContainer className={widthRestriction}>
        <p>{groups[groupId].name}</p>
        <ChevronRight bigger={Object.values(groups).length <= 3} />
      </TitleContainer>
      <CardContentContainer>
        <ImageLarge src={`${ADMIN_IMAGES_URL}/${groups[groupId].imageLight}`} />
      </CardContentContainer>
    </>
  );
};

export default EmptyCard;
